import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const allTrailsDotComLink = (
  <Link href="/" target="_blank">
    AllTrails.com
  </Link>
);

const pressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <FormattedMessage defaultMessage="AllTrails Reveals Major Update " />,
  date: 'June 13, 2024',
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <FormattedMessage defaultMessage="AllTrails Reveals Major Update " />
      </Typography>
      <Typography variant="heading200" component="h3">
        <FormattedMessage defaultMessage="Trio of enhancements represent the platform’s biggest yet" />
      </Typography>
      <Typography variant="paragraph100">
        <FormattedMessage defaultMessage="San Francisco (June  13, 2024) — AllTrails, the world's largest and most trusted platform for outdoor exploration, today announced its 2024 Summer Update, transforming how members discover and explore hundreds of thousands of trails worldwide. The update includes the introduction of curated Collections, new Park Pages, and redesigned Trail Pages to help millions of trailgoers find their outside." />
        <br />
        <FormattedMessage defaultMessage="Collectively, the changes represent AllTrails’ biggest platform experience update since the company’s founding in 2010 and reflect a growing interest in outdoor activities worldwide. AllTrails’ newest features will inspire trailgoers of all experience levels, make it more intuitive to discover outdoor destinations, and improve access to trail insights from experts and community members. " />
        <br />
        <FormattedMessage defaultMessage="“At AllTrails, we’re dedicated to helping people spend more time outdoors,” said Ron Schneidermann, Chief Executive Officer at AllTrails. “We believe everyone belongs on the trail, and our 2024 Summer Update is designed to inspire and enable adventures big and small.”" />
        <br />
        <FormattedMessage defaultMessage="Available through AllTrails’ Apple and Android apps, the 2024 Summer Update launches the following features for more than 65 million AllTrails members around the world." />
        <br />

        <div className={styles.indented}>
          <Typography variant="text100bold">
            <FormattedMessage defaultMessage="Introducing: Collections" />
          </Typography>
          <br className={styles.noMargin} />
          <Typography variant="paragraph100">
            <FormattedMessage defaultMessage="Collections offer a way for members to browse thousands of curated trails by location, popular sights and preferences such as dog-friendly, epic views, hidden gems, waterfalls and more. Designed to inspire adventure, Collections help members discover the right trail for them from more than 400,000 available on AllTrails." />
          </Typography>
          <br />
          <Typography variant="text100bold">
            <FormattedMessage defaultMessage="Introducing: Park Pages" />
          </Typography>
          <br className={styles.noMargin} />
          <Typography variant="paragraph100">
            <FormattedMessage defaultMessage="Featuring guidance from AllTrails experts, community members, and parks services, Park Pages help members explore local, state, regional and national parks worldwide. Park Pages offer comprehensive park information such as hours, fees, and top trail recommendations to make trip planning simple and convenient." />
          </Typography>
          <br />
          <Typography variant="text100bold">
            <FormattedMessage defaultMessage="Redesigned Trail Pages" />
          </Typography>
          <br className={styles.noMargin} />
          <Typography variant="paragraph100">
            <FormattedMessage defaultMessage="AllTrails overhauled its more than 400,000 Trail Pages to help trailgoers plan with confidence, making essential information more accessible and visually engaging. Key details like trail length, format, and estimated duration are more prominent, and the pages now include the ability to visually tour the trail in a dynamic Photo Gallery, view the route in 3D, assess trail conditions, and read an AI-powered summary of community reviews." />
          </Typography>
        </div>

        <br />
        <FormattedMessage defaultMessage="“AllTrails exists to help people discover and enjoy the outdoors,” said Ivan Selin, Chief Product Officer at AllTrails. “We designed our 2024 Summer Update to make it easier than ever to get out on the trail. Collections, Park Pages, and Trail Pages are exciting updates to the AllTrails experience, and we hope they inspire our community to find their next adventure and get outside. We can’t wait for you to try them!”" />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="About AllTrails" />
        </Typography>
        <br className={styles.noMargin} />
        <FormattedMessage
          defaultMessage="AllTrails helps you find your outside with inspiration from a global community of trailgoers. We connect people to the outdoors, help them discover new places, and elevate their experiences on the trail. AllTrails was awarded Apple’s 2023 iPhone App of the Year and a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to {allTrailsDotComLink} to learn more."
          values={{ allTrailsDotComLink }}
        />
      </Typography>
    </>
  )
};

export default pressRelease;
